"use client";

import ErrorSvg from "@/assets/icon/svgs/error-svg";
import { Toast } from "flowbite-react";

interface AbblToastProps {
  show: boolean;
  onClose: () => void;
  title: string;
  message?: string;
  type?: "success" | "error" | "warning";
  position?:
  | "top-right"
  | "top-left"
  | "bottom-right"
  | "bottom-left"
  | "top-center"
  | "bottom-center";
}

export default function AbblToast({
  show,
  onClose,
  title,
  message,
  type = "success",
  position = "top-right",
}: AbblToastProps) {
  if (!show) return null;

  const getPositionClasses = () => {
    switch (position) {
      case "top-right":
        return "fixed top-4 right-4";
      case "top-left":
        return "fixed top-4 left-4";
      case "bottom-right":
        return "fixed bottom-4 right-4";
      case "bottom-left":
        return "fixed bottom-4 left-4";
      case "top-center":
        return "fixed top-4 left-1/2 transform -translate-x-1/2";
      case "bottom-center":
        return "fixed bottom-4 left-1/2 transform -translate-x-1/2";
      default:
        return "fixed top-4 right-4";
    }
  };

  const isError = type === "error";
  const iconBgClass = isError
    ? "bg-red-100! text-red-500"
    : type === "warning"
      ? "bg-[#FFF8F1]! text-[#B43403]"
      : "bg-green-100! text-green-500";

  return (
    <Toast className={`${getPositionClasses()} bg-white! z-10001 w-auto`}>
      <div className="justify flex items-center">
        <div
          className={`inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${iconBgClass}`}
        >
          {isError ? (
            <svg
              className="h-5 w-5"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          ) : type === "warning" ? (
            <ErrorSvg />
          ) : (
            <svg
              className="h-5 w-5"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
          )}

        </div>
        <div className="ml-3 text-sm font-normal">
          {/* <p className="font-medium text-gray-900 dark:text-white">{title}</p> */}
          {message && (
            <p className="text-gray-500">{message}</p>
          )}
        </div>
        <button
          type="button"
          onClick={onClose}
          className="-my-1.5 rounded-lg bg-white p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-900 focus:ring-2 focus:ring-gray-300"
        >
          <svg
            className="h-5 w-5"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>
    </Toast>
  );
}
